import { Link } from "react-router-dom";

function SocialCard({ url, icon, label }: { url: string; icon: any; label: string }) {
  return (
    <Link
      to={url}
      target="_blank"
      aria-label={label}
      className="transition-all duration-300 ease-in-out transform hover:scale-110"
    >
      <div className="w-[40px] h-[40px] bg-[#D9D9D933] rounded-[6px] flex items-center justify-center">
        <span className="text-[24px] text-center text-white">{icon}</span>
      </div>
    </Link>
  );
}

export default SocialCard;
